
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cause/[tagName]/donations",
      function () {
        return require("private-next-pages/cause/[tagName]/donations.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cause/[tagName]/donations"])
      });
    }
  